import React from 'react';

interface AdminDashboardTableHitInterface {
  id: number,
  values: any, // TODO: update `any`
  selected: Array<number>,
  rowWrapperClass?: string,
  toggleSelected: (id: number) => void,
  allowBulkSelect?: boolean,
  onToggleExtraCallback?: (extraData?: any) => any,
}

const AdminDashboardTableHit: React.FC<AdminDashboardTableHitInterface> = ({
  id,
  values,
  selected,
  rowWrapperClass,
  toggleSelected,
  allowBulkSelect,
  onToggleExtraCallback,
}) => {
  const handleRowClick = (e: any) => {
    const isInteractableElement = ['BUTTON', 'A'].includes(e.target.tagName);
    if (allowBulkSelect && !isInteractableElement) {
      const currentlySelected = selected.includes(id);
      toggleSelected(id);
      if (onToggleExtraCallback) {
        onToggleExtraCallback(!currentlySelected);
      }
    }
  };

  return (
    <>
      <tr className={rowWrapperClass || undefined} onClick={handleRowClick}>
        <td key="bulk" className="align-middle pr-1 text-center">
          {allowBulkSelect && (
            // eslint-disable-next-line jsx-a11y/label-has-associated-control
            <label className="mb-0">
              <input
                className="checkbox"
                type="checkbox"
                checked={selected.includes(id)}
                readOnly
              />
            </label>
          )}
        </td>
        {values.map((hitValue) => (
          <td
            key={hitValue.key}
            className={`align-middle text-center ${hitValue?.wrapperClass || ''}`}
          >
            {hitValue.value}
          </td>
        ))}
      </tr>
    </>
  );
};

AdminDashboardTableHit.defaultProps = {
  allowBulkSelect: true,
};

export default AdminDashboardTableHit;
